import { useLocation } from 'react-router'
import type { FindingSummary } from '../../lib/api'
import { DashboardV2 } from './DashboardV2'
import { LiveDashboard } from './LiveDashboard'
import { personOf, useSession } from './session'

/**
 * Which dashboard a workspace sees. The redesign is previewed per workspace (Me.dashboardPreview, from
 * Dashboard:PreviewWorkspaces) before it becomes the default; everyone else keeps the current one.
 * /dashboard?classic shows the current one to a previewing workspace too, to compare the two.
 */
export function DashboardSwitch({ onOpen }: { onOpen?: (finding: FindingSummary) => void }) {
  const session = useSession()
  const { search } = useLocation()
  const preview = personOf(session)?.dashboardPreview === true && !new URLSearchParams(search).has('classic')

  if (!preview) return <LiveDashboard onOpen={onOpen} />
  return (
    <>
      <DashboardV2 onOpen={onOpen} />
      <p className="dv2-preview-note">
        You are previewing the new dashboard. <a href="/dashboard?classic">See the current one</a>
      </p>
    </>
  )
}
